import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../api/client';

interface Props {
  onSignOut: () => Promise<void>;
}

export default function DeleteAccountSection({ onSignOut }: Props) {
  const navigate = useNavigate();
  const [confirming, setConfirming] = useState(false);
  const [confirmText, setConfirmText] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  async function handleDelete() {
    setError('');
    setLoading(true);
    try {
      await api.deleteAccount();
      await onSignOut();
      navigate('/login', { replace: true });
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to delete account');
      setLoading(false);
    }
  }

  return (
    <div className="settings-danger-zone">
      <p className="settings-danger-text">
        This will permanently delete your account and all verification sessions. This action cannot
        be undone.
      </p>

      {error && <p className="error-msg">{error}</p>}

      {!confirming ? (
        <button type="button" className="btn btn-danger" onClick={() => setConfirming(true)}>
          Delete Account
        </button>
      ) : (
        <div className="settings-delete-confirm">
          <div className="field">
            <label className="field-label" htmlFor="delete-confirm">
              Type <strong>DELETE</strong> to confirm
            </label>
            <input
              id="delete-confirm"
              className="input"
              type="text"
              value={confirmText}
              onChange={(e) => setConfirmText(e.target.value)}
              placeholder="DELETE"
              autoComplete="off"
            />
          </div>
          <div className="settings-delete-actions">
            <button
              type="button"
              className="btn btn-danger"
              disabled={confirmText !== 'DELETE' || loading}
              onClick={() => void handleDelete()}
            >
              {loading ? 'Deleting...' : 'Confirm Deletion'}
            </button>
            <button
              type="button"
              className="btn btn-ghost"
              onClick={() => {
                setConfirming(false);
                setConfirmText('');
              }}
            >
              Cancel
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
